"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteData = void 0;
/* eslint-disable max-lines */
const monet_1 = require("monet");
const cond_1 = __importDefault(require("ramda/src/cond"));
const RemoteData = ({ value = monet_1.Maybe.Nothing(), error = monet_1.Maybe.Nothing(), loading = false }) => ({
    __inspect: {
        error,
        loading,
        value
    },
    ap: function (m) {
        return (0, exports.RemoteData)({
            error,
            loading,
            value: value.ap(m)
        });
    },
    bind: function (f) {
        return (0, exports.RemoteData)({
            error,
            loading,
            value: value.bind(f)
        });
    },
    cata: (handleLoading, handleError, handleNothing, handleContent) => {
        return (0, cond_1.default)([
            [() => loading, () => handleLoading()],
            [() => error.isSome(), () => handleError(error.some())],
            [() => monet_1.Maybe.isInstance(value), () => value.cata(handleNothing, handleContent)],
        ])();
    },
    catchMap: f => (0, exports.RemoteData)({
        error,
        loading,
        value: value.catchMap(f)
    }),
    chain: function (f) {
        return (0, exports.RemoteData)({
            error,
            loading,
            value: value.chain(f)
        });
    },
    every: f => value.every(f),
    exists: f => value.exists(f),
    filter: f => (0, exports.RemoteData)({
        error,
        loading,
        value: value.filter(f)
    }),
    filterNot: f => (0, exports.RemoteData)({
        error,
        loading,
        value: value.filterNot(f)
    }),
    // eslint-disable-next-line sonarjs/no-identical-functions
    flatMap: function (f) {
        return (0, exports.RemoteData)({
            error,
            loading,
            value: value.chain(f)
        });
    },
    fold: v => f => value.fold(v)(f),
    foldLeft: i => f => value.foldLeft(i)(f),
    foldRight: v => f => value.foldRight(v)(f),
    forEach: f => value.forEach(f),
    forall: f => value.forall(f),
    getOrElse: v => value.getOrElse(v),
    isJust: () => value.isJust(),
    isNone: () => value.isNone(),
    isNothing: () => value.isNothing(),
    isSome: () => value.isSome(),
    just: () => value.just(),
    map: function (f) {
        return (0, exports.RemoteData)({
            error,
            loading,
            value: value.map(f)
        });
    },
    mapError: f => (0, exports.RemoteData)({
        error: error.map(f),
        loading,
        value
    }),
    mapLoading: f => (0, exports.RemoteData)({
        error,
        loading: f(loading),
        value
    }),
    orElse: m => (0, exports.RemoteData)({
        error,
        loading,
        value: value.orElse(m)
    }),
    orElseRun: f => value.orElseRun(f),
    orJust: v => value.orJust(v),
    orLazy: v => value.orLazy(v),
    orNoneIf: b => (0, exports.RemoteData)({
        error,
        loading,
        value: value.orNoneIf(b)
    }),
    orNothingIf: b => (0, exports.RemoteData)({
        error,
        loading,
        value: value.orNothingIf(b)
    }),
    orNull: () => value.orNull(),
    orSome: v => value.orSome(v),
    orUndefined: () => value.orUndefined(),
    some: () => value.some(),
    to: i => value.to(i),
    toArray: () => value.toArray(),
    toEither: failMessage => value.toEither(failMessage),
    toList: () => value.toList(),
    toMaybe: () => value,
    toSet: () => value.toSet(),
    toValidation: failMessage => value.toValidation(failMessage),
    type: '@@RemoteData'
});
exports.RemoteData = RemoteData;
//# sourceMappingURL=RemoteData.js.map